
import Layout from "@/components/layout.vue";
import {defineComponent} from "vue";

export default defineComponent({
	components: {Layout}
})
